import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check';

// Your web app's Firebase configuration
// Using environment variables for security
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase App Check
// Only initialize in browser environment (not during SSR)
if (typeof window !== 'undefined') {
  // Get reCAPTCHA Enterprise site key from environment variable
  const recaptchaSiteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY;
  const isDevelopment = import.meta.env.DEV || import.meta.env.MODE === 'development';
  
  // NOTE: Firebase App Check's ReCaptchaEnterpriseProvider loads the reCAPTCHA script internally.
  // Manual script loading is optional and may conflict. We'll let Firebase handle it.
  // The reCAPTCHA documentation (docs/Security/reCAPTCHAsetup) is for direct reCAPTCHA usage,
  // not for Firebase App Check integration.
  
  if (recaptchaSiteKey) {
    try {
      // Initialize App Check with reCAPTCHA Enterprise provider
      // Firebase's ReCaptchaEnterpriseProvider will load the reCAPTCHA script internally
      initializeAppCheck(app, {
        provider: new ReCaptchaEnterpriseProvider(recaptchaSiteKey),
        isTokenAutoRefreshEnabled: true // Automatically refresh tokens
      });
      
      // Fallback: If reCAPTCHA script isn't loaded after 2 seconds, manually load it
      setTimeout(() => {
        if (typeof window.grecaptcha === 'undefined' && typeof document !== 'undefined') {
          const existingScript = document.querySelector('script[src*="recaptcha/enterprise.js"]');
          if (!existingScript) {
            const script = document.createElement('script');
            script.src = `https://www.google.com/recaptcha/enterprise.js?render=${recaptchaSiteKey}`;
            script.async = true;
            script.defer = true;
            document.head.appendChild(script);
          }
        }
      }, 2000);
      
      // Only log in development to avoid exposing App Check status in production
      if (isDevelopment) {
        console.log('Firebase App Check initialized successfully');
      }
    } catch (error) {
      // Log error in development, but don't break the app
      if (isDevelopment) {
        console.error('Firebase App Check initialization failed:', error);
      }
      // App Check failure should not prevent the app from working
      // The app will continue without App Check protection
    }
  } else {
    // Only warn in development - in production, missing key should be silent
    if (isDevelopment) {
      console.warn('VITE_RECAPTCHA_SITE_KEY not found. App Check not initialized.');
    }
  }
}

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

// Initialize Analytics (optional - only if measurementId is provided)
let analytics = null;
if (firebaseConfig.measurementId && typeof window !== 'undefined') {
  analytics = getAnalytics(app);
}

export { analytics };
export default app;














